module.exports = __webpack_public_path__ + "static/media/cost.b2df78f0.svg";